import {
  DEFAULT_MODE,
  EXPERIENCE_STORAGE_KEY,
  VALID_MODES,
  experienceModeOptions,
  getModeThemeConfig,
  isValidExperienceMode,
  modeThemeConfig,
} from "./mode-theme.config";

export {
  DEFAULT_MODE,
  EXPERIENCE_STORAGE_KEY,
  VALID_MODES,
  experienceModeOptions,
  getModeThemeConfig,
  isValidExperienceMode,
  modeThemeConfig,
};

export const experienceConfig = modeThemeConfig;

export function getExperienceConfig(mode = DEFAULT_MODE) {
  return getModeThemeConfig(mode);
}